import { $t } from '@/i18n';
import DesignerReport from '../DesignerReport';

const designerReport = new DesignerReport();
window.designerReport = designerReport;

function designerReportMod(mod, eid) {
  if (!mod || !eid) return;

  try {
    designerReport.report('click', {
      mod,
      eid,
    });
  } catch (error) {}
}

export function designerReportOffline(eid) {
  if (!eid) return;
  designerReportMod($t('k_257d514f'), eid);
}

export default designerReport;
